import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMask = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.0001 5.80251C11.4592 5.80251 10.9328 5.97795 10.5001 6.30251C9.85091 6.78917 8.22841 8.09417 7.41675 8.09417L6.16675 8.19834V15.6983L8.90425 17.3408C9.83944 17.9019 10.9095 18.1983 12.0001 18.1983"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.16667 15.6983L5.86917 15.5583C4.89918 15.1016 4.0791 14.3784 3.50467 13.4732C2.93024 12.5679 2.62514 11.518 2.625 10.4458C2.62506 10.0275 2.73078 9.61586 2.93237 9.24924C3.13396 8.88263 3.42487 8.57287 3.77813 8.34869C4.13139 8.12452 4.53554 7.9932 4.9531 7.96691C5.37065 7.94063 5.78809 8.02023 6.16667 8.19833"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 5.80251C12.5409 5.80251 13.0673 5.97795 13.5 6.30251C14.1492 6.78917 15.7717 8.09417 16.5833 8.09417L17.8333 8.19834V15.6983L15.0958 17.3408C14.1606 17.9019 13.0906 18.1983 12 18.1983"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.8333 15.6983L18.1308 15.5583C19.1007 15.1016 19.9208 14.3784 20.4952 13.4732C21.0697 12.5679 21.3748 11.518 21.3749 10.4458C21.3749 10.0275 21.2691 9.61586 21.0675 9.24924C20.866 8.88263 20.575 8.57287 20.2218 8.34869C19.8685 8.12452 19.4644 7.9932 19.0468 7.96691C18.6293 7.94063 18.2118 8.02023 17.8333 8.19833"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.91675 12.1567H14.0834"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 14.24V10.0733"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMask.displayName = 'SvgMask';
export default SvgMask;
